// extracted by mini-css-extract-plugin
export default {"wrapper":"plan-card-inner-module--wrapper--b58e9"};